var map = {
	"./country-rustic-1.jpg": 46262,
	"./country-rustic-10.jpg": 54647,
	"./country-rustic-11.jpg": 68255,
	"./country-rustic-2.jpg": 96379,
	"./country-rustic-3.jpg": 79580,
	"./country-rustic-4.jpg": 3109,
	"./country-rustic-5.jpg": 74098,
	"./country-rustic-6.jpg": 20011,
	"./country-rustic-7.jpg": 22079,
	"./country-rustic-8.jpg": 8733,
	"./country-rustic-9.jpg": 49845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42000;